import { Container } from './styles'

import reactIcon from '../../assets/react-icon.svg'
import githubIcon from '../../assets/github.svg'
import whatsapp from '../../assets/whatsapp.svg'
import telegram from '../../assets/telegram.svg'
import { useLanguage } from '../../i18n/LanguageContext'

export function Footer() {
  const { t } = useLanguage()
  return (
    <Container className="footer">
      <a href="/" className="logo">
        <span>hdarioDev</span>
      </a>
      <div>
        <p>
          {t.footer.madeWith} <img src={reactIcon} alt="React" />
        </p>
      </div>

      <div className="social-media">
        {/* <a
          href="https://www.linkedin.com/in/hdariodev"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedin} alt="Linkedin" />
        </a> */}
        <a
          href="https://github.com/hdariodev/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>
        <a
          href="https://wa.me/59178872560?text=Hello%20Dar%C3%ADo"
          target="_blank"
          rel="noreferrer"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
        <a
          href="https://t.me/hdariodev"
          target="_blank"
          rel="noreferrer"
        >
          <img src={telegram} alt="telegram" />
        </a>
      </div>
    </Container>
  )
}
